import { render, staticRenderFns } from "./OrganisationDetailWidget.vue?vue&type=template&id=23cdebcc&scoped=true"
import script from "./OrganisationDetailWidget.vue?vue&type=script&lang=js"
export * from "./OrganisationDetailWidget.vue?vue&type=script&lang=js"
import style0 from "./OrganisationDetailWidget.vue?vue&type=style&index=0&id=23cdebcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cdebcc",
  null
  
)

export default component.exports